import Vue from 'vue';

Vue.filter('translategrader', (value, locale) => {
  if (typeof value === "undefined") {
    return "";
  }
  // If it's not a dict, then return the value as it is
  if (value.constructor != Object) {
    return value;
  }
  // Else, check the current locale, and try to return the translation

  if (locale in value) {
    return value[locale];
  }

  return "";
});



// WEBPACK FOOTER //
// ./src/filters/TranslateGrader.js